import { CallMembership } from 'matrix-js-sdk/src/matrixrtc/CallMembership';
import { MatrixRTCSession, MatrixRTCSessionEvent } from 'matrix-js-sdk/src/matrixrtc/MatrixRTCSession';
import { useCallback, useEffect, useState } from 'react';

import logger from 'utils/logging/faro';

export default function useMatrixRTCSessionMemberships(rtcSession?: MatrixRTCSession): CallMembership[] {
  const [memberships, setMemberships] = useState(rtcSession?.memberships || []);

  const updateMemberships = useCallback((newMemberships: CallMembership[]) => {
    logger.info('Memberships state:', newMemberships);
    setMemberships(newMemberships);
  }, []);

  const onMembershipsChanged = useCallback(() => {
    const newMemberships = rtcSession?.memberships || [];
    updateMemberships(newMemberships);
  }, [rtcSession, updateMemberships]);

  useEffect(() => {
    if (!rtcSession) return;

    setMemberships(rtcSession.memberships);

    const onJoin = (isJoined: boolean) => {
      if (isJoined) onMembershipsChanged();
    };

    rtcSession.on(MatrixRTCSessionEvent.MembershipsChanged, onMembershipsChanged);
    rtcSession.on(MatrixRTCSessionEvent.JoinStateChanged, onJoin);

    return () => {
      rtcSession.off(MatrixRTCSessionEvent.MembershipsChanged, onMembershipsChanged);
      rtcSession.off(MatrixRTCSessionEvent.JoinStateChanged, onJoin);
    };
  }, [rtcSession, onMembershipsChanged]);

  return memberships;
}
